export default __webpack_public_path__ + "static/custom-food-21260f718aee5f0002a577d9c8386011.png";